import resume from "../../assets/sresume.jpg"

export default function Projects() {
    return (
         <div>
           <img src={resume} />
        </div>
   )
 }